import { render, staticRenderFns } from "./knit_stentering.vue?vue&type=template&id=5050d936&scoped=true"
import script from "./knit_stentering.vue?vue&type=script&lang=js"
export * from "./knit_stentering.vue?vue&type=script&lang=js"
import style0 from "./knit_stentering.vue?vue&type=style&index=0&id=5050d936&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5050d936",
  null
  
)

export default component.exports